// extracted by mini-css-extract-plugin
export default {"white":"EmailIcon_white__8QOsG","mailContainer":"EmailIcon_mailContainer__2djPI"};